import styled from 'styled-components';

export const RatingModalContentStyled = styled.div`
  padding: 32px 24px 24px;
  overflow-y: auto;
  height: 100%;
  box-sizing: border-box;

  h3 {
    margin: 0;
    padding: 0;
    font-size: 20px;
    line-height: 1.5;
  }
`;
